import {
  IonIcon,
  IonLabel,
  IonTabBar,
  IonTabButton,
  useIonRouter,
} from "@ionic/react";
import {
  addCircleOutline,
  ellipsisHorizontalSharp,
  homeOutline,
  homeSharp,
  peopleCircle,
  peopleCircleOutline,
  peopleOutline,
  peopleSharp,
  schoolOutline,
  schoolSharp,
} from "ionicons/icons";
import { useLocation } from "react-router-dom";
import { DEFAULT_HOME_PATH } from "../../utils/constents";
import "./MobileFooter.css";
import { useTranslation } from "react-i18next";
import { BiSolidCommentAdd } from "react-icons/bi";
import { IoIosPeople } from "react-icons/io";

const MobileFooter = ({ isVideosPage }) => {
  const location = useLocation();
  const router = useIonRouter();
  const { t } = useTranslation();

  // Normalize path (strip query + trailing slash) and decide when Home tab is selected.
  const normalizedPath = location.pathname.split("?")[0].replace(/\/+$/g, "");
  // Home tab should be active on /home, any /home/... route, and explicit following pages (/home/following or /following)
  const isHomeTabSelected =
    normalizedPath.startsWith("/home") || normalizedPath.endsWith("/following");

  const handleNewPostClick = (e) => {
    e.preventDefault();
    router.push(
      `/new-post${
        location.pathname.startsWith("/hashtag/")
          ? `?post=${encodeURIComponent(
              `#${location.pathname.split("/hashtag/")[1]}`,
            )}`
          : ""
      }`,
    );
  };
  const goHome = () => {
    router.push("/home", "root", "replace");
  };

  return (
    <>
      {location.pathname !== "/post" &&
        !location.pathname.startsWith("/new-post") && (
          <IonTabBar
            slot="bottom"
            className={`mobile-footer ${
              isVideosPage ? "mobile-footer-videos" : ""
            }`}
            color={isVideosPage ? "dark" : "light"}
            /* Force re-render on path change to ensure class update in edge cases */
            key={normalizedPath}
          >
            <IonTabButton
              tab="home"
              // href={DEFAULT_HOME_PATH}
              onClick={goHome}
              selected={isHomeTabSelected}
              className={isHomeTabSelected ? "tab-selected" : ""}
            >
              <IonIcon icon={isHomeTabSelected ? homeSharp : homeOutline} />
              <IonLabel className="mobile-footer-label">
                {t("mobileFooter.home")}
              </IonLabel>
            </IonTabButton>
            <IonTabButton
              tab="trending"
              href="/trending"
              className={
                location.pathname.startsWith("/trending") ? "tab-selected" : ""
              }
            >
              <IonIcon
                icon={
                  location.pathname.startsWith("/trending")
                    ? peopleSharp
                    : peopleOutline
                }
              />
              {/* <IoIosPeople
                size={30}
                style={{
                  color: location.pathname.startsWith("/trending")
                    ? "#d80621"
                    : "#000",
                }}
              /> */}

              <IonLabel className="mobile-footer-label">
                {t("mobileFooter.community")}
              </IonLabel>
              {/* <IonIcon
              icon={
                location.pathname === "/trending"
                  ? trendingUpSharp
                  : trendingUpOutline
              }
            /> */}
            </IonTabButton>
            {/* <IonTabButton tab="post" href="/post" disabled></IonTabButton> */}
            <IonTabButton
              tab="post"
              onClick={handleNewPostClick}
              // href="/new-post"
              className="footer-fab"
              // color="danger"
              size="large"
              shape="round"
              aria-label="Create a new post"
            >
              {/* <IonIcon
                icon={addCircleOutline}
                className="thin-outline"
                style={{
                  fontSize: "38px",
                  color: "var(--main-color)",
                }}
              /> */}
              <BiSolidCommentAdd
                style={{
                  fontSize: "50px",
                  color: "var(--main-color)",
                }}
              />
            </IonTabButton>
            {/* 
          <IonTabButton
            tab="ride"
            href="/ride"
            className={
              location.pathname.startsWith("/ride") ? "tab-selected" : ""
            }
          >
            <IonIcon
              icon={
                location.pathname.startsWith("/ride") ? carOutline : carOutline
              }
            />
            <IonLabel className="mobile-footer-label">Ride</IonLabel>
          </IonTabButton> */}
            <IonTabButton
              tab="study"
              // href="/study/study"
              href="/friends"
              className={
                location.pathname.startsWith("/friends") ? "tab-selected" : ""
              }
            >
              <IonIcon
                icon={
                  location.pathname.startsWith("/friends")
                    ? peopleCircle
                    : peopleCircleOutline
                }
              />
              <IonLabel className="mobile-footer-label">
                {/* {t("mobileFooter.study")} */}
                Loons
              </IonLabel>
            </IonTabButton>
            <IonTabButton
              tab="more"
              href="/more"
              className={
                location.pathname.startsWith("/more") ? "tab-selected" : ""
              }
            >
              <IonIcon icon={ellipsisHorizontalSharp} />
              <IonLabel className="mobile-footer-label">
                {t("mobileFooter.more")}
              </IonLabel>
            </IonTabButton>
          </IonTabBar>
        )}
    </>
  );
};
export default MobileFooter;
